<template>
    <component is="div" style="height: 100%">
        <slot
            :contact="contact"
            :is-white-labeled="isWhiteLabeled"
        />
    </component>
</template>

<script>
    import BaseProviderMixin from "../mixins/BaseProviderMixin";
    import ContactsMixin from "../mixins/ContactsMixin";
    import WhiteLabelingMixin from "../mixins/WhiteLabelingMixin";

    export default {
        name: "AccountVerificationEmailSentProvider",
        mixins: [
            BaseProviderMixin,
            ContactsMixin,
            WhiteLabelingMixin,
        ],
        created() {
            this.isLoading = true;
            this.loadContact()
                .catch(error => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        }
    }
</script>